module.exports = __webpack_public_path__ + "static/2front-we-1-5a40b138398e36243c5fd595b02d3b4f.png";